import { render, staticRenderFns } from "./DepositLocationLabel.vue?vue&type=template&id=286bd011&scoped=true&"
import script from "./DepositLocationLabel.vue?vue&type=script&lang=js&"
export * from "./DepositLocationLabel.vue?vue&type=script&lang=js&"
import style0 from "./DepositLocationLabel.vue?vue&type=style&index=0&id=286bd011&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286bd011",
  null
  
)

export default component.exports